import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useTheme, useThemeClassName } from '../../contexts/ThemeContext';
import Prizes from './Prizes';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/nhl-ended.module.scss';

const propTypes = {
    className: PropTypes.string,
    points: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
    prizes: PropTypes.array,
};

const defaultProps = {
    className: null,
    points: null,
    prizes: null,
};

function NhlEnded({ className, points, prizes }) {
    const { isVariant } = useTheme();
    const themeClassName = useThemeClassName(styles);
    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <h1 className={styles.title}>
                {points > 0 ? (
                    <FormattedMessage
                        defaultMessage="Congrats!{br}You have cumulated:"
                        description="Nhl game Ended title"
                    />
                ) : (
                    <FormattedMessage
                        defaultMessage="Better luck next time!"
                        description="Sport game ended title no points"
                    />
                )}
            </h1>
            <div className={styles.pill}>
                <FormattedMessage
                    defaultMessage="{count, plural, =0 {# pt} one {# pt} other {# pts!}}"
                    description="Nhl game Ended points"
                    values={{ count: points || 0 }}
                />
            </div>
            {points > 0 ? (
                <div className={styles.description}>
                    <strong>
                        <FormattedMessage
                            defaultMessage="You're the real winner tonight!"
                            description="Nhl game Ended description line 1"
                        />
                    </strong>
                    <br />
                    {isVariant('mvp') ? (
                        <FormattedMessage
                            defaultMessage="See you at the next game to make more valuable picks."
                            description="Nhl game Ended description line 2"
                        />
                    ) : (
                        <FormattedMessage
                            defaultMessage="See you at the next game for more shots to call."
                            description="Nhl game Ended description line 2"
                        />
                    )}
                </div>
            ) : null}
            {prizes && prizes.length > 0 ? (
                <Prizes
                    prizes={prizes}
                    prizeTitle={
                        <FormattedMessage
                            defaultMessage="Instant prize"
                            description="Button label"
                        />
                    }
                    className={styles.prizes}
                />
            ) : null}
            <div className={styles.results}>
                <FormattedMessage
                    defaultMessage="Your results"
                    description="Sport game ended results"
                />
            </div>
        </div>
    );
}

NhlEnded.propTypes = propTypes;
NhlEnded.defaultProps = defaultProps;

export default NhlEnded;
